import React, { useState, useEffect } from "react";
import { addAnswerKey, deleteAnswerKey } from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./AdminPanel.css";

function AnswerKeyAdminPanel() {
  const { threeTable, fetchThreeTable } = useGlobalData();
  const [jobs, setJobs] = useState([]);
  const [answerKeys, setAnswerKeys] = useState([]);
  const [formData, setFormData] = useState({ jobSlug: "" });
  const role = localStorage.getItem("role");

 
  useEffect(() => {
    if (!threeTable?.jobs?.length || !threeTable?.answerKeys?.length) {
      fetchThreeTable();
    }
  }, [threeTable?.jobs?.length, threeTable?.answerKeys?.length, fetchThreeTable]);

  useEffect(() => {
    setJobs(threeTable.jobs || []);
    setAnswerKeys(threeTable.answerKeys || []);
  }, [threeTable.jobs, threeTable.answerKeys]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addAnswerKey(formData);
    alert("Answer Key added!");
    setFormData({ jobSlug: "" });
    await fetchThreeTable();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this answer key?")) {
      await deleteAnswerKey(id);
      alert("Answer Key deleted!");
      await fetchThreeTable();
    }
  };

  const getJobTitle = (jobSlug) => jobs.find((job) => job.slug === jobSlug)?.title || jobSlug;
  const filteredAnswerKeys = answerKeys.filter((answerKey) => !formData.jobSlug || answerKey.jobSlug === formData.jobSlug);

  if (role !== "superadmin") {
    return (
      <div className="admin-panel-error">❌ Access denied! Only Superadmin can access this panel.</div>
    );
  }

  return (
    <div className="resource-admin-panel resource-admin-panel--blue">
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">Answer Key Admin Panel</h2>
          <p className="resource-admin-panel__subtext">Answer key entries ko cleaner workflow ke saath manage karo. Job choose karo, item add karo aur saved list me direct actions use karo.</p>
        </div>
        <div className="resource-admin-panel__pill">Answer Key</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Select Job</label>
          <p className="resource-admin-panel__hint">Selected job slug ke saath answer key record create hoga.</p>
          <select
            className="resource-admin-panel__select"
          value={formData.jobSlug}
          onChange={(e) => setFormData({ ...formData, jobSlug: e.target.value })}
        >
          <option value="">Select Job</option>
          {jobs.map((job) => (
            <option key={job._id} value={job.slug}>
              {job.title} ({job.slug})
            </option>
          ))}
        </select>
        </div>
        <button className="resource-admin-panel__submit" type="submit">Add Answer Key</button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Answer Keys</h3>
            <p className="resource-admin-panel__section-meta">{filteredAnswerKeys.length} items {formData.jobSlug ? `for ${formData.jobSlug}` : "across all jobs"}</p>
          </div>
        </div>

        {filteredAnswerKeys.length === 0 ? (
          <p className="resource-admin-panel__empty">Abhi selected filter ke liye koi answer key entry nahi hai.</p>
        ) : (
          <div className="resource-admin-panel__list">
            {filteredAnswerKeys.slice(0, 15).map((answerKey) => {
              const isPending = answerKey.status === "pending";
              const statusColor = isPending ? "#f7b500" : "#2ecc40";
              return (
                <div key={answerKey._id} className="resource-admin-panel__item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                  <div>
                    <p className="resource-admin-panel__item-title">{getJobTitle(answerKey.jobSlug)}</p>
                    <p className="resource-admin-panel__item-subtitle">Slug: {answerKey.jobSlug}</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                      background: statusColor,
                      color: '#fff',
                      borderRadius: 6,
                      padding: '2px 10px',
                      fontWeight: 600,
                      fontSize: 13
                    }}>{answerKey.status === "pending" ? "Pending" : "Approved"}</span>
                    <a href={`/mform/${answerKey.jobSlug}`} target="_blank" rel="noreferrer" className="resource-admin-panel__link">View Answer</a>
                    <button
                      type="button"
                      className="resource-admin-panel__delete"
                      onClick={() => handleDelete(answerKey._id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default AnswerKeyAdminPanel;
